import {
    Directive,
    ElementRef,
    HostListener
  } from '@angular/core';
  
  @Directive({
      selector: '[appDollarFormatAllowEmptySpace]',
  })
  export class DollarFormatAllowEmptySpaceDirective{
    private previousValue: string = '';
  
    constructor(private readonly el: ElementRef<HTMLInputElement>) {}
  
  
    @HostListener('input', ['$event'])
    onInput(event: Event): void {
      const input = event.target as HTMLInputElement;
      this.formatAndSetValue(input.value);
    }
  
    private formatAndSetValue(value: string): void {
        if (value === '0') {
            // Replace 0 with an empty string
            this.el.nativeElement.value = '';
            this.previousValue = '';
            return;
        }
      const rawValue = value.replace(/\D/g, '');
      const formatted = this.formatNumber(rawValue);
      this.previousValue = formatted;
      this.el.nativeElement.value = formatted;
    }
  
    private formatNumber(value: string): string {
      const number = Number(value || '0');
      return number.toLocaleString('en-US');
    }
  }
  